import { Component, Input, OnInit } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { PrivateEventBooking } from '../../../../../../../../../models/scheduled-event';
import { OrganizationConfigService } from '../../../../../../../../../services/organization-config/organization-config.service';

@Component({
  selector: 'app-private-event-refund-excess-modal',
  templateUrl: './private-event-refund-excess-modal.component.html',
  styleUrls: ['./private-event-refund-excess-modal.component.css']
})
export class PrivateEventRefundExcessModalComponent implements OnInit {

  @Input() booking: PrivateEventBooking;
  @Input() submitCallback: (amount: number) => undefined;

  public amount: number;

  public loading = false;

  public errorMessage = '';

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfig: OrganizationConfigService
  ) {}

  ngOnInit() {
    this.amount = -parseFloat(this.booking.amount_due);
  }

  public onSubmit() {
    this.errorMessage = '';

    if (!this.amount) {
      this.errorMessage = 'Select a refund amount.';
      return;
    }
    if (this.amount <= 0) {
      this.errorMessage = 'The refund amount must be a positive number.';
      return;
    }
    if (this.amount > -parseFloat(this.booking.amount_due)) {
      this.errorMessage = 'The refund amount must no greater than ' + this.orgConfig.getCurrencySymbol() +
        this.booking.amount_due.slice(1) + '.';
      return;
    }

    this.loading = true;

    this.submitCallback(this.amount);
    this.activeModal.close();
  }

}
